const NAMESPACE = "tagErrors";

const KEYS = {
    invalidTagsHeader: "invalidTagsHeader",
    brokenRefTagsHeader: "brokenRefTagsHeader",
    archivedRefTagsHeader: "archivedRefTagsHeader",
    showDetailsBtnLabel: "showDetailsBtnLabel",
    hideDetailsBtnLabel: "hideDetailsBtnLabel",
    errorSummary: "errorSummary",
    misplacedTagsHeader: "misplacedTagsHeader",
    missingUnsubscribeLinkErrorMessage: "missingUnsubscribeLinkErrorMessage",
    unexpectedUnsubscribeLinkErrorMessage: "unexpectedUnsubscribeLinkErrorMessage"
};

const MESSAGES = {
    [KEYS.invalidTagsHeader]: {
        value: "Invalid Tags:",
        comment: "Header for tags that can't be parsed due to typos or invalid parameters"
    },
    [KEYS.brokenRefTagsHeader]: {
        value: "Tags whose Reference cannot be found:",
        comment: "Header for reference tags that attempt to point to an object that wasn't found by the parser"
    },
    [KEYS.archivedRefTagsHeader]: {
        value: "Tags whose Reference is archived:",
        comment: "Header for list of tags referring to archived objects"
    },
    [KEYS.showDetailsBtnLabel]: {
        value: "Show details",
        comment: "Label for button to show details about broken tags"
    },
    [KEYS.hideDetailsBtnLabel]: {
        value: "Hide",
        comment: "Label for button to hide details about broken tags"
    },
    [KEYS.errorSummary]: {
        value: "{tagCount} tags need attention|{tagCount} tag needs attention|{tagCount} tags need attention",
        comment: "Summary explaining how many tag errors there are"
    },
    [KEYS.misplacedTagsHeader]: {
        value: "Tags that cannot be included in the subject line:",
        comment: "Header for the list of tags that cannot be included in the subject line of the communication"
    },
    [KEYS.missingUnsubscribeLinkErrorMessage]: {
        value: "Announcements must have an {unsubscribeTag} tag included in the email message.",
        comment: "Error message for when an announcement communication is missing the tag for a user to unsubscribe"
    },
    [KEYS.unexpectedUnsubscribeLinkErrorMessage]: {
        value: "Communications cannot include an {unsubscribeTag} tag. Please use an Announcement template for unsubscribe features.",
        comment: "Error message for when a communication includes an unsubscribe link tag but is not an announcement"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
